﻿import * as paths from '../utils/paths';
import * as layerTypes from '../utils/layerTypes';
import * as eventTypes from '../utils/eventTypes';
import * as defaults from '../utils/defaults';

export default class LayerSettingsHandler {
    constructor(rootURL, mapId, resourcesHandler, classId) {
        this.rootURL = rootURL;
        this.mapId = mapId;
        this.resourcesHandler = resourcesHandler;
        this.layers = {};
        this.styles = {};
        this.classId = classId;
        this.legendLayerSettingsSwitchPrefix = 'legend-layer-settings-switch-' + this.classId + '-';
        this.legendLayerDeletePrefix = 'legend-layer-delete-' + this.classId + '-';
        this.legendLayerAddPrefix = 'legend-layer-add-' + this.classId + '-';
        this.pendingChanges = false;
        this.featureHandler = null;
        this._registerNotificationHandlers();
    }

    load() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: this.rootURL + paths.MAP_LAYERS_SETTINGS_URL + this.mapId,
                async: true,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    if (result != null) {
                        this.layers = result.Layers;
                        this.styles = result.Styles;
                    } else {
                        this.layers = [];
                    }
                    resolve();
                },
                error: (e) => {
                    reject(e);
                }
            });
        });
    }

    loadExternalLayer(id) {
        this.removeExternalLayer(id);
        $.ajax({
            type: "GET",
            url: this.rootURL + paths.MAP_EXTERNAL_LAYERS_SETTINGS_URL + id,
            async: true,
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                if (result.Styles) {
                    let styleIds = Object.keys(result.Styles);

                    styleIds.forEach((styleId) => {
                        this.styles[styleId] = result.Styles[styleId];
                    });
                }

                if (result.Layers && result.Layers.length > 0) {
                    result.Layers.forEach(layer => {
                        this.addLayer(layer, 0, null);
                    });
                }
            },
            error: (e) => {
            }
        });
    }

    getLayerBbox(id, srid) {
        let filter = this.getLayerSettings(id).Filters;
        return new Promise((resolve, reject) => {
            let url = paths.MAP_LAYER_BBOX_URL;
            url = url.replaceAll('{0}', this.mapId);
            url = url.replaceAll('{1}', id);
            url = url.replaceAll('{2}', srid);

            if (filter == null) {
                filter = {};
            }

            url = url.replaceAll('{3}', JSON.stringify(filter));
            showLoadingPanel();
            $.ajax({
                type: "GET",
                url: this.rootURL + url,
                async: true,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    hideLoadingPanel();
                    resolve(result);
                },
                error: (e) => {
                    hideLoadingPanel();
                    reject(e);
                }
            });
        });
    }

    removeExternalLayer(id) {
        let layers = this.getExternalLayerSettingsByEntityId(id);

        if (layers.length > 0) {
            layers.forEach(layer => {
                this._removeLayer(this.layers, layer);
                $('.legend-layer-wrapper[data-id="' + layer.Id + '"]').remove();
                $('.legend-layer-classifications[data-id="' + layer.Id + '"]').remove();
                $event.notify(eventTypes.LAYER_REMOVED, { ids: [layer.Id] }, this, this.classId);
            });
        }
    }

    _removeLayer(layers, layer) {
        let idx = 0;
        let found = false;

        for (let i = 0; i < layers.length; i++) {
            if (layers[i].Id == layer.Id) {
                found = true;
                i = layers.length;
            } else if (layers[i].Type == layerTypes.GROUP && layers[i].Items != null) {
                this._removeLayer(layers[i].Items, layer);
                idx++;
            } else {
                idx++;
            }
        }

        if (found) {
            layers.splice(idx, 1);
        }
    }

    getLayerSettingsByName(name) {
        let result = [];

        this._findLayerSettingsByName(result, this.layers, name);

        return result;
    }

    _findLayerSettingsByName(result, layers, name) {
        if (layers != null && layers.length > 0) {
            layers.forEach(layer => {
                if (layer.Title == name) {
                    result.push(layer);
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    this._findLayerSettingsByName(result, layer.Items, name);
                }
            });
        }
    }

    getLayerSettingsByEntityId(id) {
        let result = [];

        this._findLayerSettingsByEntityId(result, this.layers, id);

        return result;
    }

    _findLayerSettingsByEntityId(result, layers, id) {
        if (layers != null && layers.length > 0) {
            layers.forEach(layer => {
                if (layer.Entity && layer.Entity.Id == id) {
                    result.push(layer);
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    this._findLayerSettingsByEntityId(result, layer.Items, id);
                }
            });
        }
    }

    getExternalLayerSettingsByEntityId(id) {
        let result = [];

        this._findExternalLayerByEntityId(result, this.layers, id);

        return result;
    }

    _findExternalLayerByEntityId(result, layers, id) {
        if (layers != null && layers.length > 0) {
            layers.forEach(layer => {
                if (layer.Id < 0 && layer.Entity.Id == id) {
                    result.push(layer);
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    this._findExternalLayerByEntityId(result, layer.Items, id);
                }
            });
        }
    }

    getLayerSettings(layerId) {
        return this._findLayer(this.layers, layerId);
    }

    getLayerSettingsByField(idField, idExtConn, objectId, ignore, hasSelection) {
        return this._findLayerByGeometryFieldId(this.layers, idField, idExtConn, objectId, ignore, hasSelection);
    }

    getAllLayersByGeometryField(idField, idExtConn) {
        let result = [];
        this._findAllLayersByGeometryFieldId(result, this.layers, idField, idExtConn);

        return result;
    }

    setLayerExtent(layerId, extent) {
        // TO DO
    }

    addConfigForLayer(layer, legend) {
        // DO NOTHING HERE
    }

    addLayer(layer, index, parentId, hide) {
        if (parentId == null) {
            let newLayers = [];

            let layersBefore = this.layers.slice(0, index);

            layersBefore.forEach(layerBefore => {
                newLayers.push(layerBefore);
            });

            newLayers.push(layer);

            let layersAfter = this.layers.slice(index);

            layersAfter.forEach(layerAfter => {
                newLayers.push(layerAfter);
            });

            this.layers = newLayers;
            $event.notify(eventTypes.LAYER_ADDED, { layerId: layer.Id, hide: hide }, this, this.classId);
        } else {
            let parent = this.getLayerSettings(parentId);

            let newLayers = [];
            let layersBefore = parent.Items.slice(0, index);

            layersBefore.forEach(layerBefore => {
                newLayers.push(layerBefore);
            });

            newLayers.push(layer);

            let layersAfter = parent.Items.slice(index);

            layersAfter.forEach(layerAfter => {
                newLayers.push(layerAfter);
            });

            parent.Items = newLayers;
            $event.notify(eventTypes.LAYER_ADDED, { layerId: layer.Id, hide: hide }, this, this.classId);
        }
    }

    _registerNotificationHandlers() {
        $event.register(eventTypes.LAYER_OPACITY_CHANGED, this._getLayerOpacityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_VISIBILITY_CHANGED, this._getLayerVisibilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_ORDER_CHANGED, this._getLayerOrderChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_SELECTABILITY_CHANGED, this._getLayerSelectabilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_STYLE_CHANGED, this._getLayerStyleChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_ANALYSIS_ADDED, this._getLayerAnalysisAddedHandler(), this, this.classId);
    }

    _getLayerOpacityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let layer = this._findLayer(this.layers, data.layerId);

                if (layer != null) {
                    layer.Opacity = data.opacity;
                    this.pendingChanges = true;
                }
            }
        };

        return handler;
    }

    _getLayerVisibilityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let layer = this._findLayer(this.layers, data.layerId);

                if (layer != null) {
                    layer.VisibleByDefault = data.visible;
                    this.pendingChanges = true;

                    if (layer.Id < 0) {
                        let url = this.rootURL + paths.HIDE_EXTERNAL_LAYER + layer.Id;

                        if (data.visible) {
                            url = this.rootURL + paths.SHOW_EXTERNAL_LAYER + layer.Id;
                        }

                        $.ajax({
                            type: "POST",
                            url: url,
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            success: (result) => {
                            },
                            error: (e) => {
                            }
                        });
                    }
                }
            }
        };

        return handler;
    }

    _getLayerOrderChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let hierarchy = data.layers;
                this._reconstructLayerTree(hierarchy);
                this.layers = hierarchy;
                this.pendingChanges = true;
            }
        };

        return handler;
    }

    _getLayerSelectabilityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let layer = this._findLayer(this.layers, data.layerId);

                if (layer != null) {
                    layer.Selectable = data.selectable;
                    this.pendingChanges = true;
                }
            }
        };

        return handler;
    }

    _getLayerStyleChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null && data.layerId != null) {
                let layer = this._findLayer(this.layers, data.layerId);

                if (layer != null) {
                    layer.IdDefaultStyle = data.styles.defaultStyle;
                    layer.IdHighlightStyle = data.styles.highlightStyle;
                    layer.IdSelectStyle = data.styles.selectStyle;
                    this.pendingChanges = true;
                }
            }
        };

        return handler;
    }

    _getLayerAnalysisAddedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null && data.id != null) {
                let analysis = JSON.parse(sessionStorage.getItem('xp_analysis'))[data.id];

                let layer = {
                    Id: data.id,
                    Title: analysis.LayerName,
                    Interpretation: layerTypes.NATIVE_XP,
                    Format: 'application/json',
                    Entity: analysis,
                    LoadingStrategy: analysis.BboxStrategy ? defaults.WFS_DEFAULT_LOADING_STRATEGY : defaults.WFS_ALL_STRATEGY,
                    Declutter: true,
                    Type: layerTypes.ENTITY,
                    VisibleByDefault: true
                };

                layer.Entity.Type = 2;

                this.addLayer(layer, 0, null);
            }
        };

        return handler;
    }

    _reconstructLayerTree(nodes) {
        nodes.forEach(node => {
            this._reconstructLayerNode(node);
        });
    }

    _reconstructLayerNode(node) {
        let layer = this._findLayer(this.layers, node.Id);

        let keys = Object.keys(layer);

        keys.forEach(key => {
            if (key != 'Items') {
                node[key] = layer[key];
            }
        });

        if (node.Items != null && node.Items.length > 0) {
            this._reconstructLayerTree(node.Items);
        }
    }

    _extractLayerIds(layer, ids) {
        ids.push(layer.Id);

        if (layer.Items != null && layer.Items.length > 0) {
            layer.Items.forEach(child => {
                this._extractLayerIds(child, ids);
            });
        }
    }

    _findLayer(layers, id) {
        if (layers != null && layers.length > 0) {
            let found;
            layers.forEach(layer => {
                if (layer.Id == id) {
                    found = layer;
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    let foundChild = this._findLayer(layer.Items, id);

                    if (foundChild != null) {
                        found = foundChild;
                    }
                }
            });

            return found;
        }
    }

    _findAllLayersByGeometryFieldId(result, layers, id, idExtConn) {
        if (layers != null && layers.length > 0) {
            layers.forEach(layer => {
                if (layer.Entity != null && layer.Entity.GeometryFieldId == id && (idExtConn == '' || idExtConn == null || layer.IdExtConn == idExtConn)) {
                    result.push(layer);
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    this._findAllLayersByGeometryFieldId(result, layer.Items, id, idExtConn);

                }
            });
        }
    }

    _findLayerByGeometryFieldId(layers, id, idExtConn, objectId, ignore, hasSelection) {
        if (layers != null && layers.length > 0) {
            let found;
            layers.forEach(layer => {
                if (layer.Entity != null && layer.Entity.GeometryFieldId == id && (idExtConn == '' || idExtConn == null || layer.IdExtConn == idExtConn )) {
                    if (objectId == null || objectId == '') {
                        if ((hasSelection && layer.IdSelectStyle != null) || !hasSelection) {
                            found = layer;
                        }
                    } else {
                        if ((hasSelection && layer.IdSelectStyle != null) || !hasSelection) {
                            let fullFeature = this.featureHandler.requestFeature(layer.Id, objectId, ignore);
                            if (fullFeature != null) {
                                found = layer;
                            }
                        }
                    }
                }

                if (found == null && layer.Items != null && layer.Items.length > 0) {
                    let foundChild = this._findLayerByGeometryFieldId(layer.Items, id, idExtConn, objectId, ignore, hasSelection);

                    if (foundChild != null) {
                        found = foundChild;
                    }
                }
            });

            return found;
        }
    }
}